import React from 'react'
import { useWindowDimensions, ScrollView, View, Image } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useNavigation } from '@react-navigation/native'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'
import { useMediaQuery } from 'react-responsive'
import RenderHtml from 'react-native-render-html'
import YoutubePlayer from "react-native-youtube-iframe"

import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'

const source1 = {
  html: `
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Programa CO.NEXO</p>
<p style='text-align:left; font-size: madium; font-weight: bold; color: #5c0b78'>Da ideia ao negócio</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>O Programa CO.NEXO é uma Pré-incubadora de projetos voltada para empreendedores e aspirantes a empreendedores que precisam de suporte e orientação para transformar ideias em negócios.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>A Pré-Incubação compreende o conjunto de atividades que servem para estimular o empreendedorismo e preparar os projetos que tenham potencial de negócios para se estruturarem, serem absorvidos por Incubadoras ou se inserirem diretamente no mercado. Na jornada empreendedora, a pré-incubação é a fase de validação da ideia, na qual é dada especial ênfase no incentivo e disseminação da mentalidade e cultura empreendedoras.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Entre os benefícios do CO.NEXO estão a oferta de uma infraestrutura física compartilhada, assessoramento na modelagem do negócio, mentorias para elaboração do plano de negócios e demais ações necessárias à constituição do empreendimento, e preparação para realizar pitchs (apresentação rápida do negócio despertando interesse em públicos específicos). O Programa oferece também workshops, cursos, oficinas, palestras sobre as principais ferramentas de desenvolvimento e gestão do negócio, reforçando a capacidade empreendedora dos participantes. .</p>
`
};

const source2 = {
  html: `
  <ul>
  <li>Viabilizar novos negócios para a cidade de Vitória da Conquista e região</li>
  <li>Fomentar o empreendedorismo em novos segmentos</li>
  <li>Estruturar projetos inovadores, viabilizando o seu desenvolvimento</li>
  <li>Maturar os empreendimentos existentes para que os mesmos não estejam nas estatísticas de negócios fechados em menos de 5 anos de existência por falta de estruturação</li>
  </ul>
  `
};

const source3 = {
  html: `
  <ul>
  <li>Acesso a infraestrutura</li>
  <li>Networking</li>
  <li>Credibilidade</li>
  <li>Acompanhamento individual e personalizado aos pré-incubados, com consultores do Senac</li>
  <li>Capacitações empresariais gratuitas</li>
  <li>Acesso a potenciais fontes de financiamento</li>
  <li>Networking</li>
  </ul>
  `
};

const source4 = {
  html: `
  <p style='text-align:left; font-size: smaller; line-height: 18px;'><strong>1. Queremos ser Empreendedores</strong> – Pessoas interessadas em abrir o seu próprio negócio, mas que ainda não possui uma ideia, a atitude empreendedora adequada e/ou o segmento de atuação.<br/><strong>2. Potencial Empreendedor</strong> – Pessoas com uma ideia de negócio que queiram tirá-la do papel e transformá-la em um empreendimento viável, bem como aquelas que precisam desenvolver habilidades empreendedoras antes de avançarem na jornada empreendedora.<br/><strong>3. Empreendendo um Negócio</strong> – Empreendedores que se encontram na primeira fase de gestão (com foco em informais, autônomos e MEIs), mas precisam ainda estruturar o empreendimento, validar seu modelo de negócio e/ou testar a viabilidade mercadológica e/ou técnica do seu produto/serviço.
  </p>
  `
};

const source5 = {
  html: `
  <p style='text-align:left; font-size: smaller; line-height: 18px;'>Os candidatos deverão realizar inscrição</br>Após validação da inscrição, será agendada uma entrevista por meio da qual será diagnosticado o nível em que o candidato se encontra na jornada empreendedora. Na ocasião, será identificada a trilha que melhor atende as suas necessidades.<br/>Para formalizar o ingresso na pré-incubação, os candidatos deverão proceder à matrícula, cujos documentos são os que seguem:</p>
  <ul>
  <li>RG</li>
  <li>CPF</li>
  <li>Comprovante de Residência</li>
  <li>Comprovante de Escolaridade</li>
  </ul>
  `
};

const source6 = {
  html: `
  <p style='text-align:left; font-size: smaller; line-height: 18px;'>O programa acontece de forma contínua, de novembro de 2022 a agosto de 2023, estando as inscrições condicionadas à capacidade de atendimento do Senac.</p>
  `
};

const source7 = {
  html: `
  <p style='text-align:left; font-size: smaller; line-height: 18px;'>A participação é sem custo para os pré-incubados.<br/>Os empreendimentos pré-incubados deverão cumprir as obrigações estipuladas no Termo de Compromisso de Participação da Pré-Incubação, que será assinado após a entrevista com o consultor do Senac.<br/>Os pré-incubados terão acesso às orientações, coaching, mentorias, palestras, oficinas, cursos, promovidos pelo programa.<br/>Durante o processo de pré-incubação, o pré-incubado deverá realizar as atividades recomendadas, fazendo as entregas solicitadas no tempo pactuado com o mentor.<br/>Ao encerramento do processo de pré-incubação, o pré-incubado será avaliado, obrigatoriamente, através da entrega do canvas do modelo de negócio e apresentação no formato pitch da empresa.<br/>O não cumprimento das atividades acordadas no prazo estipulado acarretará no desligamento do projeto pré-incubado do processo de pré-Incubação.<br/>Para receber o certificado, o pré-incubado deverá ter 75% de frequência mínima nas atividades do programa.</p>
  `
};

const source8 = {
  html: `
  <p style='text-align:left; font-size: smaller; line-height: 18px;'>O período máximo de permanência será de 6 (seis) meses. Se o projeto não evoluir, ocorrerá o encerramento de toda e qualquer relação do Senac com o pré-incubado.</p>
  `
};

const source9 = {
  html: `
  <p style='text-align:left; font-size: smaller; line-height: 18px;'>Para ingresso no programa CO.NEXO, serão priorizados projetos/empreendimentos nos setores de comércio e serviços, que sejam inovadores, liderados por mulheres e/ou geradores de Impacto Social e Ambiental.</p>
  `
};


const source10 = {
  html: `
  <ul>
  <li>Pessoa física maior de 16 anos (individualmente ou em grupo por ideia).</li>
  <li>Pessoa jurídica, incluindo autônomos e MEIs.</li>
  </ul>
  `
};

export default function Conexo() {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const navigation = useNavigation()

  const _goForm = () => {
    navigation.navigate('FormRDConexo', {})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }


      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="CO.NEXO - Pré-incubadora" subtitle="Pré-incubadora de Negócios" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-5 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
            <View style={[tailwind('mb-10'), {marginTop: isLargeScreen ? 110 : 150}]}>
                  <>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source1}
                  />
                </View>  
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>OBJETIVOS</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source2}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>VANTAGENS DE SE INSERIR EM UM PROGRAMA DE PRÉ-INCUBAÇÃO</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source3}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>PERFIS DOS BENEFICÁRIOS</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source4}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>FORMA DE INGRESSO NO CO.NEXO</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source5}
                  />
                </View>
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>QUANDO INGRESSAR / PERÍODO DE INSCRIÇÕES</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source6}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>OBRIGAÇÕES E CUSTOS ASSOCIADOS</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source7}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>PRAZO DE PERMANÊNCIA</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source8}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>ÁREAS DE INTERESSE</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source9}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>CANDIDATOS ELEGÍVEIS</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source10}
                  />
                </View>
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                </>
              </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
